import axios from 'axios';

export class EventService {

    getEvents() {
        return axios.get('/api/activeObservationDates')
            .then(response => response.data);
    }
}